var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTollsAndServices = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Parking-Ramp--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Parking Ramp Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.05 14.16 0.89 -0.71a1 1 0 0 0 0.16 -1.39 1 1 0 0 0 -1.4 -0.16l-0.7 0.56a0.25 0.25 0 0 1 -0.25 0 0.27 0.27 0 0 1 -0.15 -0.21l-0.11 -1.1a3 3 0 0 0 -3 -2.72H5.76a3 3 0 0 0 -3 2.7l-0.11 1.11a0.24 0.24 0 0 1 -0.15 0.2 0.25 0.25 0 0 1 -0.25 0l-0.68 -0.55a1 1 0 0 0 -1.2 1.56l0.88 0.7a0.25 0.25 0 0 1 0.09 0.19 0.22 0.22 0 0 1 -0.09 0.19 2.72 2.72 0 0 0 -1 2.11v2.23A1.74 1.74 0 0 0 2 20.6h0.74a0.25 0.25 0 0 1 0.25 0.25v1.24a1.49 1.49 0 0 0 3 0v-1.24a0.25 0.25 0 0 1 0.25 -0.25h5a0.25 0.25 0 0 1 0.25 0.25v1.24a1.49 1.49 0 0 0 3 0v-1.24a0.25 0.25 0 0 1 0.25 -0.25h0.7A1.73 1.73 0 0 0 17 18.87v-2.23a2.69 2.69 0 0 0 -1 -2.1 0.25 0.25 0 0 1 0 -0.38ZM4 18.87a1.49 1.49 0 1 1 1.49 -1.49A1.49 1.49 0 0 1 4 18.87Zm0.86 -5.2a0.25 0.25 0 0 1 -0.19 -0.09 0.22 0.22 0 0 1 -0.06 -0.19l0.21 -2a1 1 0 0 1 1 -0.9h5.77a1 1 0 0 1 1 0.92l0.2 2a0.22 0.22 0 0 1 -0.06 0.19 0.23 0.23 0 0 1 -0.18 0.09Zm8.55 5.2a1.49 1.49 0 1 1 1.49 -1.49 1.49 1.49 0 0 1 -1.53 1.49Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.85 13a0.24 0.24 0 0 0 -0.27 0.05l-5 4.95a0.26 0.26 0 0 0 -0.07 0.16v3a0.25 0.25 0 0 0 0.15 0.23 0.24 0.24 0 0 0 0.27 -0.05l5 -5a0.26 0.26 0 0 0 0.07 -0.17v-3a0.23 0.23 0 0 0 -0.15 -0.17Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.55 15.37a0.25 0.25 0 0 0 0.15 0.23 0.24 0.24 0 0 0 0.27 0l4.57 -4.6a0.21 0.21 0 0 0 0.07 -0.18 0.23 0.23 0 0 0 -0.08 -0.18 1.16 1.16 0 0 0 -0.77 -0.29H20a0.25 0.25 0 0 1 -0.16 -0.06L8.67 0.67a1 1 0 1 0 -1.29 1.5l11.08 9.5a0.25 0.25 0 0 1 0.09 0.19Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.85 18.8a0.24 0.24 0 0 0 -0.27 0.05l-4.25 4.25a0.24 0.24 0 0 0 -0.06 0.23 0.23 0.23 0 0 0 0.15 0.18 1.15 1.15 0 0 0 0.37 0.06h3A1.24 1.24 0 0 0 24 22.33V19a0.25 0.25 0 0 0 -0.15 -0.2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTollsAndServices);
export default ForwardRef;